module.exports = __webpack_public_path__ + "img/mail.cb8035ab.svg";